import { render, staticRenderFns } from "./SessionContainer.vue?vue&type=template&id=319a64a0&scoped=true&"
import script from "./SessionContainer.vue?vue&type=script&lang=js&"
export * from "./SessionContainer.vue?vue&type=script&lang=js&"
import style0 from "./SessionContainer.vue?vue&type=style&index=0&id=319a64a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a64a0",
  null
  
)

export default component.exports